const BRANDS = [
  'CAT', 'Komatsu', 'Volvo', 'CASE', 'Hyundai', 'John Deere', 'New Holland',
  'JCB', 'SANY', 'XCMG', 'LiuGong', 'Genie', 'JLG', 'Haulotte',
  'Tigercat', 'Ponsse', 'Komatsu Forest',
  'Bosch Rexroth', 'Parker', 'Danfoss', 'Eaton', 'HYDAC',
];

export default function BrandsSection() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
      {BRANDS.map((brand) => (
        <div
          key={brand}
          className="group flex items-center justify-center p-4 bg-background-50 rounded-md border border-background-200/60 hover:border-primary-200/40 transition-all duration-300 cursor-default"
        >
          <span className="text-xs md:text-sm font-semibold text-foreground-500 tracking-wider whitespace-nowrap group-hover:text-foreground-800 transition-colors duration-300">
            {brand}
          </span>
        </div>
      ))}
    </div>
  );
}